export const limitedNumber = (input: number, limit: number = 99): string => {
  return input > limit ? `${limit}+` : String(input)
}

export const thousandSeparate = (input: string | number): string => {
  const parts = String(input).split('.')

  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  const decimalPart = parts[1] || ''

  return `${integerPart}${decimalPart ? `.${decimalPart}` : ''}`
}

export const bigintPower = (base: bigint, expo: bigint) => {
  if (expo <= BigInt(0)) {
    return BigInt(1)
  }

  let res = base

  for (let index = 1; index < expo; index += 1) {
    res *= base
  }

  return res
}
